import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Errors } from '@atlas/ui';

import { getIsFieldRequired } from 'common/utils/utils';

const Field = ({ children, className, options }) => {
  const { active, checkOnChanges, errors, rules, touched } = options;

  const isRequiredSymbol = getIsFieldRequired(rules);

  const fieldClassName = cx(
    'field',
    {
      required: isRequiredSymbol,
    },
    className,
  );

  // Mapping errors & applying label params using field ruleOption
  const fieldErrors = React.useMemo(() => {
    if ((touched || (checkOnChanges && active)) && Array.isArray(errors)) {
      return errors.map(({ message, ruleOption }) => ({
        message,
        params: { ruleOption },
      }));
    }
  }, [touched, checkOnChanges, active, errors]);

  return (
    <div className={fieldClassName}>
      {children}
      <Errors errors={fieldErrors} />
    </div>
  );
};

Field.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  options: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    checkOnChanges: PropTypes.bool.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
    rules: PropTypes.arrayOf(PropTypes.object).isRequired,
    touched: PropTypes.bool.isRequired,
  }).isRequired,
};

export default Field;
